<button (click)="submitForm ? submitForm.emit() : ''" [class]="'btn btn-'+type" [disabled]="disabled"
		[ngClass]="{'btn-block': block, 'disabled': disabled, 'submitting': submitting}" [style.min-width.px]="minWidth"
		[style.pointer-events]="submitting ? 'none' : 'auto'" id="{{id}}"
		nz-button type="submit ">
	<span *ngIf="!submitting">{{name}}</span>
	<!-- <div *ngIf="submitting" class="ui active small inline loader" style="pointer-events: none"></div> -->
	<ng-container *ngIf="submitting">
		<ng-template #indicatorTemplate><i nz-icon nzType="loading"></i></ng-template>
		<nz-spin [nzIndicator]="indicatorTemplate" nzSimple style="pointer-events: none"></nz-spin>
	</ng-container>
</button>
